import { render, staticRenderFns } from "./DrawerCard.vue?vue&type=template&id=0489dd02&scoped=true"
import script from "./DrawerCard.vue?vue&type=script&lang=ts"
export * from "./DrawerCard.vue?vue&type=script&lang=ts"
import style0 from "./DrawerCard.vue?vue&type=style&index=0&id=0489dd02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0489dd02",
  null
  
)

export default component.exports